
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { t } from '../../../../../helpers/translator';
import StaticStake from '../../../../components/staticStake';
import Keyboard from '../../../../components/virtualKeyboard';
import { roundStake } from '../../../../../helpers/sport/betslip';
import { GetCurrencyConfig, GetTerminalBalance, GetToken, GetUser } from '../../../../../helpers/selectors';
import MoneyAmount from '../../../../components/moneyAmount';
import Config from '../../../../../config/main';
import { betBuilderPlaceBet, calculateBetBuilderPossibleWin } from './helpers';
import Zergling from '../../../../../helpers/zergling';
import { PrintBetBuilderTicket } from '../../../../../actions/terminal';
import { ClosePopup } from '../../../../../actions/ui';
import Helpers from '../../../../../helpers/helperFunctions';

const BetBuliderBetslip = ({ betData, onClear, user, terminalBalance, currencyConfig, token, partner, dispatch }) => {
    const [stake, setStake] = useState();
    const [placeBetError, setPlaceBetError] = useState();
    const [placeBetLoading, setPlaceBetLoading] = useState(false);
    const [keyboardSettings, setKeyboardSettings] = useState();
    const currency = JSON.parse(sessionStorage.getItem("authData")).currency;

    const possWin = useMemo(() => calculateBetBuilderPossibleWin(+stake, betData.price, currencyConfig), [stake, betData, currencyConfig]);
    
    const taxAmount = useMemo(() => stake && Helpers.calculateTaxForReturnedAndProfit(
        partner?.taxPercent,
        partner?.tax_type === 2 ? possWin : possWin - stake,
        partner?.tax_amount_ranges
    ), [stake]);

    const placeBetDisabled = placeBetLoading || !stake || stake > terminalBalance;

    const toggleKeyboard = (e) => {
        if (keyboardSettings) {
            !e.defaultPrevented && setKeyboardSettings(null);
        }
        else {
            const keyboardSettings = {
                currentValue: stake,
                changeHandler: setStake,
                processHandler: stake => parseFloat(stake).toString() === stake ? roundStake(stake, currencyConfig.rounding) : stake,
                onCloseCallback: () => setKeyboardSettings(null),
                offset: e.target.offsetTop,
            }

            setKeyboardSettings(keyboardSettings);
        }
    };

    const placeBet = async () => {
        setPlaceBetLoading(true);

        const placeBetResponse = await betBuilderPlaceBet(betData.betslipUid, stake);
        if (!placeBetResponse) return

        if (placeBetResponse.data?.Id) {
            const ticketResult = await Zergling.checkTerminalBetTicket(placeBetResponse.data.Id * 10, token);

            ticketResult?.data && dispatch(PrintBetBuilderTicket(JSON.stringify({
                ...ticketResult.data,
                price: betData.formattedPrice,
            })));

            setPlaceBetError(null);
            dispatch(ClosePopup());
        } else {
            setPlaceBetError(placeBetResponse.data)
        }

        setPlaceBetLoading(false);
    }


    return <div className="bet-builder-betslip">
        {keyboardSettings && <Keyboard
            settings={keyboardSettings}
            bindToElement={false}
        />}
        <div className="selections">
            <div className="selections-header">
                <div className="selection-header-left">
                    {t('Betslip')} <div className="count-badge-block">{betData.selections.length}</div>
                </div>
                <div className="selection-header-right">
                    <button className="selections-clear-all" onClick={onClear}>
                        <i className="global-icon icon-bin" />
                        {t('Clear All')}
                    </button>
                </div>
            </div>
            <div className="section-wrap">
                {betData.selections.map(item =>
                    <div key={item} className="selection"><span className="green-text">{item}</span></div>)
                }
            </div>
        </div>
        <div className="bet-info">
            <div className="bet-info-top">
                <div onClick={toggleKeyboard} className="single-form-item">
                    <span className="single-form-item-txt">{stake || t("Stake...")}</span>
                </div>
                <StaticStake
                    setStake={setStake}
                    activeStake={+stake}
                    user={user}
                    terminalBalance={terminalBalance}
                    currency={currency}
                />
            </div>
            <div className="bet-info-bottom">
                {
                    placeBetError && <div className="bet-info-text-block error">{placeBetError}</div>
                }
                <div className="bet-info-text-block">{t('Total Odd:')} <span className="green-text">{betData.formattedPrice}</span></div>
                {possWin && <div className="bet-info-text-block">{t('Possible win:')}
                    <span>
                        <MoneyAmount amount={possWin} />
                    </span>
                </div>}
                {taxAmount && <div className="bet-info-text-block">{t('Tax on Return:')}
                    <span>
                        <MoneyAmount amount={taxAmount} />
                    </span>
                </div>}
                {taxAmount && <div className="bet-info-text-block">{t('Total win:')}
                    <span>
                        <MoneyAmount amount={possWin - taxAmount} />
                    </span>
                </div>}
                <button disabled={placeBetDisabled} className="bet-info-place-bet-button" onClick={placeBet}>{t('Place-Bets')}</button>
            </div>
        </div>
    </div>
};

BetBuliderBetslip.propTypes = {
    betData: PropTypes.object.isRequired,
    onClear: PropTypes.func.isRequired,
};

const mapStateToProps = () => (
    createSelector(
        [
            GetUser,
            GetCurrencyConfig,
            GetTerminalBalance,
            GetToken,
            state => state.swarmConfigData.partner,
        ],
        (user, currencyConfig, terminalBalance, token, partner) => ({
            user,
            currencyConfig,
            terminalBalance,
            token,
            partner
        }),
    )
);

export default connect(mapStateToProps)(BetBuliderBetslip);